import { StaffQualificationEnum } from '../../types/enums/staff/staff-qualifications.enum'
import { MissionTrackingFilters } from '../../types/models/mission-tracking/mission-tracking'

export const transformMissionTrackingFiltersToUrl = (filters?: MissionTrackingFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.qualifications && filters.qualifications.length > 0)
    searchParams.set('qualifications', filters.qualifications.join(','))

  if (filters.contractDateRange?.startDate && filters.contractDateRange?.endDate) {
    searchParams.set('contractDateRangeFrom', filters.contractDateRange.startDate)
    searchParams.set('contractDateRangeTo', filters.contractDateRange.endDate)
  }

  if (filters.periodId) searchParams.set('periodId', filters.periodId.toString())

  if (filters.date) searchParams.set('date', filters.date)

  if (filters.missionsCount) searchParams.set('missionsCount', filters.missionsCount.toString())

  if (filters.documents !== undefined) searchParams.set('documents', filters.documents.toString())

  if (filters.contractSentAt !== undefined)
    searchParams.set('contractSentAt', filters.contractSentAt.toString())

  if (filters.dpaeDownloadAt !== undefined)
    searchParams.set('dpaeDownloadAt', filters.dpaeDownloadAt.toString())

  if (filters.dpaeFilledAt !== undefined)
    searchParams.set('dpaeFilledAt', filters.dpaeFilledAt.toString())

  return searchParams.toString()
}

export const transformUrlToMissionTrackingFilters = (
  searchParams: URLSearchParams
): MissionTrackingFilters => {
  const filters: MissionTrackingFilters = {}

  const qualifications = searchParams.get('qualifications')
  if (qualifications)
    filters.qualifications = qualifications.split(',') as StaffQualificationEnum[]

  const contractDateRangeFrom = searchParams.get('contractDateRangeFrom')
  const contractDateRangeTo = searchParams.get('contractDateRangeTo')
  if (contractDateRangeFrom && contractDateRangeTo) {
    filters.contractDateRange = {
      startDate: contractDateRangeFrom,
      endDate: contractDateRangeTo
    }
  }

  const periodId = searchParams.get('periodId')
  if (periodId) filters.periodId = parseInt(periodId)

  const date = searchParams.get('date')
  if (date) filters.date = date

  const missionsCount = searchParams.get('missionsCount')
  if (missionsCount) filters.missionsCount = parseInt(missionsCount)

  const documents = searchParams.get('documents')
  if (documents) filters.documents = documents === 'true'

  const contractSentAt = searchParams.get('contractSentAt')
  if (contractSentAt) filters.contractSentAt = contractSentAt === 'true'

  const dpaeDownloadAt = searchParams.get('dpaeDownloadAt')
  if (dpaeDownloadAt) filters.dpaeDownloadAt = dpaeDownloadAt === 'true'

  const dpaeFilledAt = searchParams.get('dpaeFilledAt')
  if (dpaeFilledAt) filters.dpaeFilledAt = dpaeFilledAt === 'true'

  return filters
}
